/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';

import courseraCVectorBackgroundImage from 'images/degree-home/help-tip-vector.svg';

const styles = {
  card: () => css`
    display: flex;
    padding: var(--cds-spacing-400) var(--cds-spacing-400) var(--cds-spacing-200);
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1 0 0;
    align-self: stretch;
    border-radius: var(--cds-spacing-100);
    background: var(--cds-color-neutral-background-primary-weak);
    box-sizing: border-box;
    min-width: 225px;
    background-image: url(${courseraCVectorBackgroundImage});
    background-repeat: no-repeat;
    background-position: top right;
    background-size: contain;

    ${breakpoints.down('xs')} {
      min-width: 100%;
      width: 100%;
      padding: var(--cds-spacing-300) var(--cds-spacing-300) var(--cds-spacing-200);
      border-left: none;
      border-right: none;
      border-radius: 0;
    }
  `,
};

const HelpTipCard = ({ children }: React.PropsWithChildren) => <div css={styles.card}>{children}</div>;

export default HelpTipCard;
